module.exports = __webpack_public_path__ + "static/media/order-service-bullets.bdb7e9ed.svg";